import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantTask } from '../mutations/updateParticipantTask.mutation';
import type {
  UpdateParticipantTaskMutation,
  UpdateParticipantTaskMutationVariables,
} from '../types';

export const useUpdateParticipantTaskMutation = (
  options?: MutationOptions<UpdateParticipantTaskMutation, UpdateParticipantTaskMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantTask), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => {
          return query.queryKey.includes('tasks');
        },
      });
    },
  });
};
